"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isDev_1 = require("../isDev");
exports.GoogleAnalytics = {
    gtag: undefined,
    id: undefined,
    initialise: function (config) {
        if (!config) {
            throw new Error("You must initialise the analytics service");
        }
        var ref = window.document.getElementsByTagName("script")[0];
        var script = window.document.createElement("script");
        this.id = isDev_1.isDev() ? config.dev : config.prod;
        script.src = "https://www.googletagmanager.com/gtag/js?id=" + this.id;
        ref.parentNode.insertBefore(script, ref);
        window["dataLayer"] = window["dataLayer"] || [];
        function gtag() {
            // @ts-ignore
            // eslint-disable-next-line prefer-rest-params
            dataLayer.push(arguments);
        }
        // @ts-ignore
        gtag("js", new Date());
        // @ts-ignore
        gtag("config", this.id);
        this.gtag = gtag;
    },
    recordPageview: function (path) {
        try {
            this.gtag("config", this.id, {
                // eslint-disable-next-line @typescript-eslint/camelcase
                page_path: path,
            });
        }
        catch (e) {
            console.warn("Failed to record pageview");
        }
    },
    recordEvent: function (action) {
        try {
            this.gtag("event", action);
        }
        catch (e) {
            console.warn("Failed to record event, you need to initialise analytics https://bitbucket.org/intermediasecurity/core-components/wiki/Home");
        }
    },
};
